var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.273 5.037a2.42 2.42 0 0 1 2.418 2.418v9.09a2.42 2.42 0 0 1-2.418 2.418H4.728a2.42 2.42 0 0 1-2.418-2.418v-9.09a2.42 2.42 0 0 1 2.418-2.418zM3.509 10.78v5.764c0 .673.546 1.218 1.219 1.218h14.545c.672 0 1.218-.545 1.218-1.218v-5.764zm1.219-4.545a1.22 1.22 0 0 0-1.22 1.219v2.127h16.983V7.455a1.22 1.22 0 0 0-1.218-1.22z"
  })));
};
export default SvgCreditCard;